import { Component, OnInit } from '@angular/core';
import { NotificacaoChatComponent } from "../notificacao-chat/notificacao-chat.component";
import { CompartilhamentoService } from 'app/services/compartilhamento/compartilhamento.service';
import { CommonModule } from '@angular/common';
import { DadosNotificacao } from 'app/interfaces/Notificacao';
import { WebsocketTipo } from 'app/interfaces/websocket';
import { WebsocketService } from 'app/services/websocket/websocket.service';
import { Mensagem } from 'app/interfaces/Chat';
import { MapearDadosService } from 'app/services/mapear-dados/mapear-dados.service';
import { DatetimeService } from 'app/services/datetime/datetime.service';
import { ChatService } from 'app/services/chat/chat.service';
import { SonsServiceService } from 'app/services/sons/sons-service.service';

@Component({
  selector: 'app-notificacoes-gerais-chat',
  standalone: true,
  imports: [NotificacaoChatComponent, CommonModule],
  templateUrl: './notificacoes-gerais-chat.component.html',
  styleUrl: './notificacoes-gerais-chat.component.css'
})
export class NotificacoesGeraisChatComponent implements OnInit {
  private readonly EVENTO_NOVA_MENSAGEM: string = '.nova-mensagem';
  protected heartbeatIntervalId: any;
  private canalChat: string = '';
  private eventoIniciado = false;
  private eventoObservable: any;

  constructor(
    private readonly webSocketService: WebsocketService,
    private readonly mapearDadosService: MapearDadosService,
    private readonly datetimeService: DatetimeService,
    private readonly chatService: ChatService,
    private readonly compartilhamentoService: CompartilhamentoService,
    private readonly sonsServiceService: SonsServiceService
  ){}

  ngOnInit(): void {
    const loginUsuarioAtual: string = this.buscarLoginUsuarioAtual();
    const clienteId: string = this.buscarIdClienteAtual();
    this.iniciarHeartbeat(loginUsuarioAtual, clienteId);
    this.compartilhamentoService.notificacaoChat$.subscribe(valor => {
      if (!this.eventoIniciado && valor) {
        this.assinarEventoChat();
      }
      
      if (this.eventoIniciado && !valor) {
        this.fecharConexaoEventoChat();
      }

    });
  }
  
  public dadosNotificacoes: DadosNotificacao[] = [];

  public fecharNotificacao(indexNotificacao: number): void {
    this.dadosNotificacoes.splice(indexNotificacao, 1);
  }

  protected assinarEventoChat(): void {
    this.eventoIniciado = true
    const loginUsuarioAtual: string = this.buscarLoginUsuarioAtual();
    const clienteId: string = this.buscarIdClienteAtual();
    this.canalChat = `chat.cliente.${clienteId}.usuario.${btoa(loginUsuarioAtual)}`;
    
    this.eventoObservable = this.webSocketService.inscreverEvento(WebsocketTipo.Chat, this.canalChat, this.EVENTO_NOVA_MENSAGEM).subscribe({
      next: dados => this.notificarMensagemRecebida(dados?.mensagem),
      error: err => console.error(err)
    });
  }
  
  protected fecharConexaoEventoChat(): void {
    this.eventoObservable.unsubscribe();
    this.eventoIniciado = false;
  }

  protected notificarMensagemRecebida(mensagem?: Mensagem) {
    if(mensagem) {
      this.sonsServiceService.tocarSomNotificacao();
      const objectMapping = {
        'From':'mandadoPor',
        'Message':'mensagem',
        'TsCreatedAt':'hora'
      }
      const dadosNotificacao: DadosNotificacao = this.mapearDadosService.mapearDadosPara<Mensagem, DadosNotificacao>(mensagem, objectMapping, false);
      dadosNotificacao.hora = this.datetimeService.extrairHora(dadosNotificacao.hora);
      this.dadosNotificacoes.unshift(dadosNotificacao);  
    }
  }

  protected iniciarHeartbeat(login: string, clienteId: string): void {
    this.heartbeatIntervalId = setInterval(() => {
      this.chatService.heartbeat(login, Number(clienteId)).subscribe(
        () => {
          this.chatService.heartbeat(login, Number(clienteId));
        }
      );
    }, 20000);
  }

  protected buscarLoginUsuarioAtual(): string {
    return localStorage.getItem('usuarioLogin') ?? '';
  } 

  protected buscarIdClienteAtual(): string {
    return localStorage.getItem('clienteId') ?? '';
  }


}
